export function removeBackslashes(str) {
	let result = '';

	if (str) {
		result = str.replace(/\\/g, '');
	}
	
	return result;
}